import React from 'react'
import Navbar from '../Header/Navbar'
import NavbarSecond from '../Header/NavbarSecond'
import MobileNavbar from '../Header/MobileNavbar'
import Footer from '../Footer/Footer'
import DirectorMessagePage from './DirectorMessagePage'

const DirectorMessageMainPage = () => {
    return (
        <>
            <Navbar />
            <NavbarSecond />
            <MobileNavbar />
            <DirectorMessagePage/>
            <Footer />
        </>
    )
}

export default DirectorMessageMainPage